<template>
  <div>
    <search
      :title="`${$t('modal.employee')}`"
      :items="employees"
      idProperty="EmployeeId"
      nameProperty="EmployeeName"
      @triggerClick="triggerClick"
      @remove="remove"
      :searchItems="searchItems"
    />
    <employee-select
      :isMultiple="true"
      :trigger="trigger"
      :defaultItems="defaultItems"
      @onSaved="add"
    />
  </div>
</template>

<script>
import search from "./Search";
import employeeSelect from "@/components/selects/EmployeeSelects";

export default {
  data() {
    return {
      trigger: false,
      employees: [],
      defaultItems: undefined,
    };
  },
  props: {
    searchItems: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    searchItems(value) {
      if (JSON.parse(sessionStorage.getItem("isSamePage")) && value.Employee) {
        this.employees = value.Employee;
      }
    },
  },
  components: {
    search,
    employeeSelect,
  },
  methods: {
    triggerClick() {
      this.defaultItems = [...this.employees];
      this.trigger = !this.trigger;
    },
    add(items) {
      this.employees = items;
      this.set();
    },
    remove(index) {
      if (!this.employees[index]) return;
      this.employees.splice(index, 1);
      this.set();
    },
    set() {
      this.$emit("set", this.employees);
    },
  },
};
</script>
